import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const ConsumerAuthContext = createContext();
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ConsumerAuthProvider = ({ children }) => {
  const [consumer, setConsumer] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('consumer_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const storedToken = localStorage.getItem('consumer_token');
    if (storedToken) {
      try {
        const response = await axios.get(`${API}/consumer/auth/me`, {
          headers: { Authorization: `Bearer ${storedToken}` }
        });
        setConsumer(response.data);
        setToken(storedToken);
      } catch (error) {
        localStorage.removeItem('consumer_token');
        setToken(null);
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/consumer/auth/login`, { email, password });
    localStorage.setItem('consumer_token', response.data.token);
    setToken(response.data.token);
    setConsumer(response.data.consumer);
    return response.data;
  };

  const signup = async (consumerData) => {
    const response = await axios.post(`${API}/consumer/auth/register`, consumerData);
    localStorage.setItem('consumer_token', response.data.token);
    setToken(response.data.token);
    setConsumer(response.data.consumer);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('consumer_token');
    setToken(null);
    setConsumer(null);
  };

  const updateConsumer = (data) => {
    setConsumer(prev => ({ ...prev, ...data }));
  };

  return (
    <ConsumerAuthContext.Provider value={{ 
      consumer, 
      token, 
      loading, 
      login, 
      signup, 
      logout, 
      setConsumer,
      updateConsumer,
      isAuthenticated: !!token 
    }}>
      {children}
    </ConsumerAuthContext.Provider>
  );
};

export const useConsumerAuth = () => useContext(ConsumerAuthContext);
